import PortfolioCoinTransactionController from "./portfolio_coin_transactions_controller";

export default class extends PortfolioCoinTransactionController {
  static targets = PortfolioCoinTransactionController.targets.concat(["transactionFormTabs"]);

  editTransaction() {
    // portfolio coin transaction
    const transactionId = event.currentTarget.dataset.transactionId,
      editModalSelector = event.currentTarget.dataset.editModalSelector,
      fetchPath = event.currentTarget.dataset.fetchPath;

    fetch(`${fetchPath}/${transactionId}`, {credentials: "same-origin"})
      .then(response => response.json())
      .then(transaction => {
        const actionPath = this.formTarget.getAttribute("data-action-path");
        this._toggleTransactionFormTab(transaction);
        this._preFillTransactionForm(transaction);
        this.formTarget.action = `${actionPath}/${transaction.id}`;

        $(`#${editModalSelector}`).modal('show');
      });
  }

  _toggleTransactionFormTab(transaction) {
    if (["buy", "sell"].includes(transaction.transaction_type)) {
      const selectedTab = this.transactionFormTabsTarget
        .querySelector(`a[aria-control="#nav-${transaction.transaction_type}"]`);

      selectedTab.classList.add("active");
      selectedTab.setAttribute("aria-selected", true);
    } else {
      const selectedTab = this.transactionFormTabsTarget
        .querySelector('a[aria-control="#nav-transfer"]');

      selectedTab.classList.add("active");
      selectedTab.setAttribute("aria-selected", true);
    }

    this.toggleInputField(transaction.transaction_type);
  }

  _preFillTransactionForm(transaction) {
    const transaction_date = new Date(
      transaction.transaction_timestamp
    ).toISOString().substring(0, 10);

    this.priceInputFieldTarget.querySelector("input").value = transaction.price;
    this.dateInputFieldTarget.querySelector("input").value = transaction_date;
    this.noteInputFieldTarget.querySelector("input").value = transaction.notes;
    this.feeInputFieldTarget.querySelector("input").value = transaction.fees;
    this.quantityInputFieldTarget.querySelector("input").value = transaction.quantity;
    this.transferInputFieldTarget.querySelector("select").value = transaction.transaction_type;
    this.transactionTypeTarget.value = transaction.transaction_type;
  }

  onBeforeSend(xhr) {
    xhr.detail[1].data += "&_method=patch"
  }

  onPostSuccess(e) {
    let [data, status, xhr] = e.detail;
    const successResponse = JSON.parse(xhr.response);

    this._clearFormErrors();
    this.postMessageTarget.classList.add("text-primary");
    this.postMessageTarget.innerHTML = successResponse.message;
    window.location.reload()
  }
}
